import { render, staticRenderFns } from "./FormGetBranch.vue?vue&type=template&id=e4b554fe&scoped=true&"
import script from "./FormGetBranch.vue?vue&type=script&lang=js&"
export * from "./FormGetBranch.vue?vue&type=script&lang=js&"
import style0 from "./FormGetBranch.vue?vue&type=style&index=0&id=e4b554fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b554fe",
  null
  
)

export default component.exports